"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preact2 = _interopRequireDefault(require("downshift/preact"));

var _HitContainerControl = _interopRequireDefault(require("./HitContainerControl"));

var _SearchBox = require("./SearchBox");

var _index = require("./index");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function itemToString(i) {
  return i ? i.title : i;
}

var AlgoliaSearchForControl = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AlgoliaSearchForControl, _Component);

  var _super = _createSuper(AlgoliaSearchForControl);

  function AlgoliaSearchForControl() {
    (0, _classCallCheck2.default)(this, AlgoliaSearchForControl);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AlgoliaSearchForControl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          refine = _this$props.refine,
          allSearchResults = _this$props.allSearchResults,
          updateSearch = _this$props.updateSearch,
          callback = _this$props.callback,
          exclude = _this$props.exclude,
          placeholder = _this$props.placeholder,
          searchById = _this$props.searchById,
          finalInput = _this$props.finalInput,
          submitIconType = _this$props.submitIconType,
          withoutRedirect = _this$props.withoutRedirect,
          searchBoxClassName = _this$props.searchBoxClassName;
      var communityHits = [];

      if ((0, _index.isMultiIndexResult)(allSearchResults)) {
        var _allSearchResults$glo, _allSearchResults$glo2;

        communityHits = ((_allSearchResults$glo = allSearchResults === null || allSearchResults === void 0 ? void 0 : (_allSearchResults$glo2 = allSearchResults[(0, _globals.default)('communityId')]) === null || _allSearchResults$glo2 === void 0 ? void 0 : _allSearchResults$glo2.hits) !== null && _allSearchResults$glo !== void 0 ? _allSearchResults$glo : []).filter(_index.isCommunityResult);
      } else {
        var _allSearchResults$hit;

        communityHits = ((_allSearchResults$hit = allSearchResults === null || allSearchResults === void 0 ? void 0 : allSearchResults.hits) !== null && _allSearchResults$hit !== void 0 ? _allSearchResults$hit : []).filter(_index.isCommunityResult);
      }

      return (0, _preact.h)(_preact2.default, {
        itemToString: itemToString,
        onChange: function onChange(item, root) {
          if (item !== null) {
            callback(item);
            root.clearSelection();
          }
        }
      }, function (_ref) {
        var getInputProps = _ref.getInputProps,
            getItemProps = _ref.getItemProps,
            highlightedIndex = _ref.highlightedIndex,
            setHighlightedIndex = _ref.setHighlightedIndex,
            openMenu = _ref.openMenu,
            inputValue = _ref.inputValue,
            reset = _ref.reset,
            isOpen = _ref.isOpen;
        return (0, _preact.h)("div", {
          className: "algolia-search-container"
        }, (0, _preact.h)(_SearchBox.SearchBox, {
          isControl: true,
          newStyle: true,
          placeholder: placeholder,
          reset: reset,
          refine: refine,
          updateSearch: updateSearch,
          setHighlightedIndex: setHighlightedIndex,
          inputValue: inputValue !== null && inputValue !== void 0 ? inputValue : '',
          getInputProps: getInputProps,
          openMenu: openMenu,
          isOpen: isOpen,
          key: "search",
          submitIconType: submitIconType,
          withoutRedirect: withoutRedirect,
          className: searchBoxClassName
        }), inputValue && isOpen ? (0, _preact.h)(_HitContainerControl.default, {
          key: "hits-container",
          inputValue: inputValue,
          hits: communityHits,
          highlightedIndex: highlightedIndex,
          getItemProps: getItemProps,
          searchById: searchById,
          finalInput: finalInput,
          exclude: exclude
        }) : null);
      });
    }
  }]);
  return AlgoliaSearchForControl;
}(_preact.Component);

var _default = AlgoliaSearchForControl;
exports.default = _default;